import EventEmitter from 'events';

import {DEVICE_DISCONNECT} from '../../consts/app/eventTypes';

let instance = null;

export default class DisconnectEventEmitter extends EventEmitter {
    constructor(createNew) {
        if (createNew && instance) {
            instance.removeAllDisconnectListeners();
            instance = null;
        }

        if (instance) {
            return instance;
        }

        super();
        instance = this;
    }

    emitDisconnect(...args) {
        this.emit(DEVICE_DISCONNECT, ...args);
    }

    onDisconnect(func) {
        this.on(DEVICE_DISCONNECT, func);
    }

    offDisconnect(func) {
        this.off(DEVICE_DISCONNECT, func);
    }

    removeAllDisconnectListeners() {
        this.removeAllListeners(DEVICE_DISCONNECT);
    }
}
